import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import { Container, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";
import { Buttons } from "../components/Buttons/Buttons";
import { useNavigate } from "react-router-dom";
// import Banner from './components/Banner';
const Home = () => {
  useEffect(() => {
    AOS.init({
      offset: 100, // Offset (in px) from the original trigger point
      delay: 500, // Values from 0 to 3000, with step 50ms
      duration: 3000, // Values from 0 to 3000, with step 50ms
      easing: "ease", // Default easing for AOS animations
      mirror: true, // Whether elements should animate out while scrolling past them
    });
  }, []);
  const navigate = useNavigate();
  const handlenavigate = () => {
    navigate("/products");
  };

  return (
    <>
      <div className="over">
        <AppBar />
        <img
          src={require("../assets/images/banner/banner2.jpg")}
          className="img-fluid w-100"
          alt="product name"
          data-aos="flip-right"
        />
        {/* <Banner/> */}

        {/* intro start */}
        <div className="padding bg-white">
          <Container>
            <Row className="align-items-center">
              <Col lg="12" className="text-center pb-4">
                <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 rounded-pill bold mb-2 text-uppercase letter-spacing-1">
                  ✨ Sivakasi Direct Wholesaler ✨
                </span>
                <h1 className="bold text-center lg-font text-dark mt-2 mb-2">
                  Welcome to <span className="text-danger">GMR Crackers</span>
                </h1>
                <p className="text-muted bold fs-5 mx-auto" style={{ maxWidth: "700px" }}>
                  Celebrate this Diwali with authentic Sivakasi firecrackers at up to <strong className="text-danger">80% Flat Discount</strong>!
                </p>
              </Col>
              <Col lg="6" xs={12} className="py-3">
                <div data-aos="fade-right">
                  <h2 className="bold text-dark mb-3">
                    Diwali Best Crackers in <span className="text-danger">Sivakasi</span>
                  </h2>

                  <p className="regular text-secondary mb-3 lh-lg">
                    We supply <strong className="text-dark">premium quality crackers at genuine factory prices</strong>. Crackers are available in diverse specifications tailored to every family and corporate requirement. We provide a vast range of firecrackers including <strong className="text-dark">single and multi-sound crackers, sparklers, ground chakkars, flower pots, twinkling stars, pencils, fancy aerial rockets, 30-shot to 240-shot sky fireworks, whistling fountains, chorsa garlands, atom bombs, and electric crackers</strong>.
                  </p>
                  <p className="regular text-secondary mb-3 lh-lg">
                    We are specialists in <strong className="text-danger">fireworks gift boxes</strong> with custom assortment options. All our crackers are manufactured as per statutory norms with <strong className="text-dark">low emission, safe formulas, and superior vivid colours</strong>.
                  </p>
                  <p className="regular text-secondary lh-lg mb-0">
                    At GMR Crackers, <strong className="text-dark">customer satisfaction and safety</strong> are our highest priorities. Enjoy nationwide parcel delivery with prompt 24-hour order processing!
                  </p>
                </div>
              </Col>
              <Col lg="6" className="py-3 text-center" data-aos="fade-left">
                <div className="p-2 bg-light rounded-4 shadow-sm border">
                  <img
                    src={require("../assets/images/home+image.jpg")}
                    className="img-fluid rounded-3"
                    alt="GMR Crackers Celebration"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* intro end */}

        {/* products start */}
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col lg="10" xs={12} className="text-center py-3">
              <span className="badge bg-warning-subtle text-dark border border-warning-subtle px-3 py-1 rounded-pill bold text-uppercase">
                💥 Wide Product Range
              </span>
              <h2 className="bold text-dark mt-2 mb-3">Our Cracker Categories</h2>
              <p className="regular text-muted lh-base">
                Our motto is to make every festival celebration bright, colorful, and completely safe. With <strong className="text-dark">over 200 varieties of crackers</strong> sourced directly from the heart of Sivakasi, we offer economical pricing, verified quality, and fast courier dispatch.
              </p>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/bombs.jpg")}
                    className="img-fluid"
                    alt="One Sound Crackers"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">One Sound Crackers</h5>
                  <p className="regular text-white-50 small mb-0">Kuruvi, Laxmi, Spider, 2 Sound...</p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/chakkars.jpg")}
                    className="img-fluid"
                    alt="Ground Chakkars"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">Ground Chakkars</h5>
                  <p className="regular text-white-50 small mb-0">Chakkar Big, Asoka, Deluxe, Special...</p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/flowerpots.jpg")}
                    className="img-fluid"
                    alt="Flower Pots"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">Flower Pots</h5>
                  <p className="regular text-white-50 small mb-0">Big, Small, Colorkoti, Deluxe...</p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/wala.jpg")}
                    className="img-fluid"
                    alt="Garlands Wala"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">Garlands (Wala)</h5>
                  <p className="regular text-white-50 small mb-0">Deluxe, Giant Garlands, 1000 to 10000 Wala...</p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/sparklers.jpg")}
                    className="img-fluid"
                    alt="Sparklers"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">Sparklers</h5>
                  <p className="regular text-white-50 small mb-0">Red, Green, Electric, Crackling, 10cm to 50cm...</p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/rockets.jpg")}
                    className="img-fluid"
                    alt="Rockets"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">Rockets</h5>
                  <p className="regular text-white-50 small mb-0">Baby Rockets, Lunik, Whistling, Parachute...</p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/fountain.jpg")}
                    className="img-fluid"
                    alt="Fountains & Fancy"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">Fountains & Novelties</h5>
                  <p className="regular text-white-50 small mb-0">Fun Zone, Photo Flash, Drone, Peacock...</p>
                </div>
              </div>
            </Col>
            <Col lg="4" md="4" xs="12" className="py-3 text-center">
              <div className="home-product rounded-3 shadow-sm" data-aos="flip-left">
                <div>
                  <img
                    src={require("../assets/images/giftbox.jpg")}
                    className="img-fluid"
                    alt="Gift Box"
                  />
                </div>
                <div className="home-product-name">
                  <h5 className="bold text-white mb-1">Assorted Gift Boxes</h5>
                  <p className="regular text-white-50 small mb-0">20 Items, 30 Items, VIP Family Packs...</p>
                </div>
              </div>
            </Col>
            <Col lg="12">
              <div className="text-center py-4" data-aos="fade-up">
                <button
                  className="btn btn-danger btn-lg rounded-pill px-5 py-3 bold shadow-sm"
                  onClick={handlenavigate}
                >
                  💥 View Complete Price List & Order Online (80% Off)
                </button>
              </div>
            </Col>
          </Row>
        </Container>
        {/* products end */}

        {/* counter start */}
        <div className="counter padding bg-overlay z">
          <Container>
            <Row>
              <Col lg="3" xs={6} className="py-3">
                <div className="z text-center" data-aos="fade-up">
                  <div className="counter-box">
                    <CountUp end={15} delay={1.2} />
                    <span className="text-warning">+</span>
                  </div>
                  <div className="bold text-white fs-6 text-uppercase letter-spacing-1">
                    Years of Trust
                  </div>
                </div>
              </Col>
              <Col lg="3" xs={6} className="py-3">
                <div className="z text-center" data-aos="fade-down">
                  <div className="counter-box">
                    <CountUp end={200} delay={1.2} />
                    <span className="text-warning">+</span>
                  </div>
                  <div className="bold text-white fs-6 text-uppercase letter-spacing-1">
                    Cracker Varieties
                  </div>
                </div>
              </Col>
              <Col lg="3" xs={6} className="py-3">
                <div className="z text-center" data-aos="fade-right">
                  <div className="counter-box">
                    <CountUp end={1000} delay={1.2} />
                    <span className="text-warning">+</span>
                  </div>
                  <div className="bold text-white fs-6 text-uppercase letter-spacing-1">
                    Happy Families
                  </div>
                </div>
              </Col>
              <Col lg="3" xs={6} className="py-3">
                <div className="z text-center" data-aos="fade-left">
                  <div className="counter-box">
                    <CountUp end={100} delay={1.2} />
                    <span className="text-warning">%</span>
                  </div>
                  <div className="bold text-white fs-6 text-uppercase letter-spacing-1">
                    Quality Assured
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {/* counter end */}

        <img
          src={require("../assets/images/banner/banner_nine.jpg")}
          className="img-fluid w-100"
          alt="Diwali Fireworks Banner"
          data-aos="flip-right"
        />

        {/* retail & wholesale cards */}
        <div className="padding bg-white">
          <Container>
            <Row className="g-4 align-items-center">
              <Col lg="6" className="py-2">
                <div className="p-3 bg-light rounded-4 shadow-sm border text-center" data-aos="flip-right">
                  <img
                    src={require("../assets/images/retail.png")}
                    className="img-fluid rounded-3"
                    alt="Retail Crackers"
                  />
                  <h4 className="bold text-dark mt-3 mb-1">Retail Orders Welcome</h4>
                  <p className="regular text-muted small mb-0">Special family packs & gift assortments at lowest prices</p>
                </div>
              </Col>
              <Col lg="6" className="py-2">
                <div className="p-3 bg-light rounded-4 shadow-sm border text-center" data-aos="flip-left">
                  <img
                    src={require("../assets/images/wholesale.png")}
                    className="img-fluid rounded-3"
                    alt="Wholesale Crackers"
                  />
                  <h4 className="bold text-dark mt-3 mb-1">Wholesale & Bulk Orders</h4>
                  <p className="regular text-muted small mb-0">Direct factory supply for shops, communities & dealers</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* sale bg start*/}
        <div className="salebg">
          <div className="sale">
            <Container>
              <Row className="align-items-center">
                <Col lg="8" md="12" xs="12" className="py-3">
                  <div data-aos="fade-right">
                    <span className="badge bg-warning text-dark bold px-3 py-1 rounded-pill mb-2">
                      SIVAKASI DIRECT FACTORY
                    </span>
                    <h1 className="bold text-white mb-3">Direct Wholesalers in Sivakasi</h1>
                    <div className="regular text-white-50">
                      <p className="text-white fs-5 mb-2 lh-base">
                        We deliver genuine fireworks directly from our factory in Sivakasi with maximum safety and unbeatable discounts.
                      </p>
                      <p className="text-white-50 mb-0">
                        Get year-round supply with direct factory dispatch, authentic GST bills, and safe transport to your nearest transport hub.
                      </p>
                    </div>
                  </div>
                </Col>
                <Col
                  lg="4"
                  md="12"
                  xs="12"
                  className="py-3 text-center text-lg-end"
                >
                  <button
                    data-aos="fade-up"
                    className="btn btn-warning btn-lg rounded-pill px-5 py-3 bold text-dark shadow"
                    onClick={handlenavigate}
                  >
                    🎉 Shop Online Now !
                  </button>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        {/* sale bg end*/}
        <Footer />
      </div>
    </>
  );
};

export default Home;
